import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3.6 20.4l16.8 -16.8","key":"svg-0"}],["path",{"d":"M6 8h4m-2 -2v4","key":"svg-1"}],["path",{"d":"M14 16h4","key":"svg-2"}],["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-3"}]]

const IconExposure = createReactComponent('outline', 'exposure', 'Exposure', __iconNode);

export default IconExposure;